import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=29f2c8f8&scoped=true&"
import script from "@/views/Groups/CreateDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Groups/CreateDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Groups/create-dialog.scss?vue&type=style&index=0&id=29f2c8f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f2c8f8",
  null
  
)

export default component.exports